// src/components/InstallPrompt.js — iOS SAFE
import { useState, useEffect } from 'react'
import './InstallPrompt.css'

export default function InstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null)
  const [showIOS, setShowIOS]           = useState(false)
  const [dismissed, setDismissed]       = useState(() => {
    try { return localStorage.getItem('pwa-dismissed') === 'true' } catch { return true }
  })

  useEffect(() => {
    try {
      // Already installed
      if (window.matchMedia('(display-mode: standalone)').matches) return

      // Android Chrome install prompt
      const handler = e => { e.preventDefault(); setInstallEvent(e) }
      window.addEventListener('beforeinstallprompt', handler)

      // iOS Safari install hint — only on HTTPS and not already installed
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      const isStandalone = window.navigator.standalone === true
      if (isIOS && !isStandalone) setShowIOS(true)

      return () => {
        try { window.removeEventListener('beforeinstallprompt', handler) } catch {}
      }
    } catch {}
  }, [])

  if (dismissed || (!installEvent && !showIOS)) return null

  async function handleInstall() {
    if (!installEvent) return
    try { installEvent.prompt(); const { outcome } = await installEvent.userChoice; if (outcome === 'accepted') setInstallEvent(null) }
    catch {}
  }

  function dismiss() {
    try { localStorage.setItem('pwa-dismissed', 'true') } catch {}
    setDismissed(true)
  }

  return (
    <div className="install-prompt">
      <div className="install-prompt__icon">📱</div>
      <div className="install-prompt__content">
        <p className="install-prompt__title">Install the App</p>
        <p className="install-prompt__sub">
          {showIOS ? 'Tap Share then Add to Home Screen to install' : 'Add Sky Bri Private to your home screen'}
        </p>
      </div>
      <div className="install-prompt__actions">
        {!showIOS && <button className="btn btn--gold btn--sm" onClick={handleInstall}>Install</button>}
        <button className="btn btn--ghost btn--sm" onClick={dismiss}>{showIOS ? 'Got it' : 'Later'}</button>
      </div>
    </div>
  )
}
